import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { HEADER_MENUS } from '../config/header-menu.data';
import { MaintenanceComponent } from 'src/app/components/all-modals/maintenance/maintenance.component';

@Component({
  selector: 'app-landing-footer',
  templateUrl: './landing-footer.component.html',
  styleUrls: ['./landing-footer.component.scss']
})
export class LandingFooterComponent implements OnInit {
  menus = [];

  currentYear: any;

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.menus = HEADER_MENUS;
    this.currentYear = new Date().getFullYear();
  }

  openComingSoonModal() {
    this.modalService.open(ComingSoonComponent, { centered: true });
  }

  navigateToLogin(){
    const modalRef = this.modalService.open(MaintenanceComponent, { centered: true });
  }

}
